import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "Layout";
import NonAuthLayout from "Layout/NonAuthLayout";

//routes
import { publicRoutes, authProtectedRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

const Index = () => {
  console.log("authProtectedRoutes:: ", authProtectedRoutes);
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={<NonAuthLayout> {route.component} </NonAuthLayout>}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthProtected permissions={route?.permissions}>
                  <Layout>{route.component}</Layout>{" "}
                </AuthProtected>
              }
            />
          ))}
        </Route>

        {/* Fallback route for undefined paths */}
        <Route
          path="*"
          element={
            <AuthProtected>
              <Layout>
                <Navigate to="/dashboard" />
              </Layout>
            </AuthProtected>
          }
        />
      </Routes>
    </React.Fragment>
  );
};

export default Index;
